import { BrowserRouter } from "react-router-dom";
import Routers from "@/router/routers";

const Router: React.FC = () => (
    <BrowserRouter>
        <Routers />
    </BrowserRouter>
)

export default Router;